/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonTag,
    JsonTagFromJSON,
    JsonTagFromJSONTyped,
    JsonTagToJSON,
} from './JsonTag';

/**
 * 
 * @export
 * @interface ApiResultOfJsonTag
 */
export interface ApiResultOfJsonTag {
    /**
     * 
     * @type {JsonTag}
     * @memberof ApiResultOfJsonTag
     */
    data?: JsonTag;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTag
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonTag
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTag
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTag
     */
    result?: ApiResultOfJsonTagResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonTagResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonTagFromJSON(json: any): ApiResultOfJsonTag {
    return ApiResultOfJsonTagFromJSONTyped(json, false);
}

export function ApiResultOfJsonTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonTagFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonTagToJSON(value?: ApiResultOfJsonTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonTagToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

